import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'tallymark-2', 'Tallymark2', [["path",{"d":"M10 5l0 14","key":"svg-0"}],["path",{"d":"M14 5l0 14","key":"svg-1"}]]);